/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listingbuttonsmissingdirections3Inputs */

const en_listingbuttonsmissingdirections3 = /** @type {(inputs: Listingbuttonsmissingdirections3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No address on the map –`)
};

const de_listingbuttonsmissingdirections3 = /** @type {(inputs: Listingbuttonsmissingdirections3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Adresse auf der Karte –`)
};

/**
* | output |
* | --- |
* | "No address on the map –" |
*
* @param {Listingbuttonsmissingdirections3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const listingbuttonsmissingdirections3 = /** @type {((inputs?: Listingbuttonsmissingdirections3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listingbuttonsmissingdirections3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listingbuttonsmissingdirections3(inputs)
	return de_listingbuttonsmissingdirections3(inputs)
});
export { listingbuttonsmissingdirections3 as "listingButtonsMissingDirections" }